import React from 'react'
import { Link } from 'react-router-dom'

interface CheckoutProps {
  productId?: string
}

export const Checkout: React.FC<CheckoutProps> = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl w-full text-center">
        <div className="mx-auto h-16 w-16 flex items-center justify-center bg-blue-100 rounded-full mb-8">
          <svg className="h-10 w-10 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4m.6 8l1.6-8M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17M17 13v4a2 2 0 01-2 2H9a2 2 0 01-2-2v-4m8 0V9a2 2 0 00-2-2H9a2 2 0 00-2-2" />
          </svg>
        </div>
        
        <h1 className="text-4xl font-extrabold text-gray-900 mb-4">
          Payment System Coming Soon
        </h1>
        
        <p className="text-xl text-gray-700 mb-8 leading-relaxed">
          We're integrating secure payment processing for our professional timeshare exit guide.
          For now, please register to receive your free consultation and guide access.
        </p>
        
        <div className="bg-blue-50 border-l-4 border-blue-600 p-6 mb-8 text-left">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-blue-600" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-bold text-blue-800">What You Get For Free Right Now</h3>
              <ul className="text-sm text-blue-700 mt-2 space-y-1">
                <li>• Professional consultation to assess your timeshare situation</li>
                <li>• Custom exit strategy recommendations</li>
                <li>• Access to sample legal templates and documents</li>
                <li>• Direct contact with our expert team</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link 
            to="/register"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors text-center no-underline"
          >
            Get Free Consultation Now
          </Link>
          
          <Link 
            to="/"
            className="bg-gray-600 hover:bg-gray-700 text-white font-bold py-3 px-8 rounded-lg transition-colors text-center no-underline"
          >
            Back to Homepage
          </Link>
        </div>
        
        <div className="mt-8 text-sm text-gray-600">
          <p>Questions? Contact our support team for immediate assistance.</p>
        </div>
      </div>
    </div>
  )
}
